import React from 'react';
import Tooltip from 'flow/components/ui-components/Tooltip';
import useAppContext from 'flow/hooks/useAppContext';
import { useAppSelector } from 'flow/hooks/useRedux';
import {
    selectKeysWaitingQueueItems,
    selectWaitingQueueItem,
} from 'flow/selectors/queue-selectors';
import { QueueKey } from 'flow/types/EntityKeys';
import TimeSinceJoinedItem from '../TimeSinceJoinedItem';

interface Props {
    queueKey: QueueKey;
}
const QueueRowWaitTime = ({ queueKey }: Props) => {
    const { i18next } = useAppContext();
    const firstWaitingItemKey = useAppSelector((state) =>
        selectKeysWaitingQueueItems(state, queueKey),
    )?.get(0);

    const firstItemJoinTime = useAppSelector((state) =>
        selectWaitingQueueItem(state, firstWaitingItemKey),
    )?.get('joinTime');

    if (!firstItemJoinTime) return null;

    return (
        <Tooltip
            label={i18next.t('Supervisor.QueueRow.Tooltip.Label.JoinTime')}
            placement="top-end"
        >
            <div className="flex h-8 min-w-14 cursor-default items-center justify-center rounded-sm border-gray-300 bg-gray-200 px-2 text-base whitespace-nowrap">
                <TimeSinceJoinedItem joinTime={firstItemJoinTime} />
            </div>
        </Tooltip>
    );
};

export default QueueRowWaitTime;
